<div class="flex w-3/4 flex-col">
	@if (selectPaymentMethod()) {
		<div>
			<h2>Seleccioná el medio de pago</h2>
		</div>
		<div class="flex flex-col gap-5 mt-10">
			<app-payments-list
				[paymentMethods]="userPaymentMethods()"
				[loading]="paymentsLoading()"
				(setPaymentEvent)="setExistingPayment($event)" />
		</div>
		<activar-button
			color="default"
			class="mt-5 mb-5"
			fill="clear"
			expand="block"
			text="+ Agregar"
			(click)="showAddPaymentMethod()" />
	}

	@if (addPaymentMethod) {
		<div class="mt-50">
			<h2>Agregar medio de pago</h2>
			@if (userPaymentMethods().length > 0) {
				<activar-back-button
					text="Volver"
					(click)="showPaymentMethods()" />
			}

			<app-add-payment
				[paymentGateways]="quoterState().risk.paymentMethods"
				(EventPaymentSubmit)="setPayment($event, false)" [needSecurityCode]="needSecurityCode()"/>
		</div>
	}

	@if (addSecurityCode()) {
		<div>
			<activar-back-button text="Volver" (click)="showPaymentList()" />
			<h3 class="mt-5">Ingresá el código de seguridad</h3>
			<app-add-security-code
				(EventSecurityCode)="setSecurityCode($event)" />
		</div>
	}
</div>
